import HgIcon from '../../../HgIcon'
import HgTooltip from '../../../HgTooltip'
import {
  type PricingCardListProps,
  type CompanyListItemProps,
  type GenericListItemProps,
} from './types'

// TODO: Ask if we still need this
const CompanyListItem = ({companyName, companyLogo}: CompanyListItemProps) => {
  return (
    <div className="flex flex-row items-start space-x-s2">
      {companyLogo && (
        <div className="flex h-20 w-20 items-center justify-center">
          <div className="flex h-[16px] max-h-[16px] w-[16px] max-w-[16px] [&_*]:h-full [&_*]:w-full [&_*]:fill-icon-default">
            {companyLogo}
          </div>
        </div>
      )}
      <p className="text-text-default arcadia-body-3">{companyName}</p>
    </div>
  )
}

const GenericListItem = ({
  iconType,
  body,
  caption,
  tooltipProps,
}: GenericListItemProps) => {
  return (
    <div className="flex h-fit flex-row items-start space-x-s2">
      {iconType && (
        <div className="flex h-[22px] w-16 items-center justify-center">
          <HgIcon className="text-icon-default" iconType={iconType} size="medium" />
        </div>
      )}
      <div className="flex flex-col items-start">
        <div className="flex gap-s2">
          <p className="text-text-default arcadia-body-3 [&_br]:hidden md:[&_br]:block">
            {body}
          </p>
          {tooltipProps && (
            <div className="flex items-center justify-center">
              <HgTooltip
                {...tooltipProps}
                classNames={{trigger: 'data-[state]:ml-0'}}
              />
            </div>
          )}
        </div>
        {caption && (
          <p className="text-text-subdued arcadia-body-4 [&_br]:hidden md:[&_br]:block">
            {caption}
          </p>
        )}
      </div>
    </div>
  )
}
export const HgPricingCardList = ({heading, listItems}: PricingCardListProps) => {
  return (
    <article className="flex flex-col">
      <h2 className="pb-s2 text-text-default arcadia-heading-9 empty:hidden">
        {heading}
      </h2>
      <ul className="flex flex-col space-y-s2">
        {listItems.map(item => (
          <li key={item.id}>
            {'companyName' in item && 'companyLogo' in item ? (
              <CompanyListItem {...item} />
            ) : (
              <GenericListItem {...item} />
            )}
          </li>
        ))}
      </ul>
    </article>
  )
}
